'use strict';

var base = require('./base');
var detail = require('base/product/detail');
var quantitySelect = require('../components/quantitySelect');
var clientSideValidation = require('../components/clientSideValidation');
var storeLocatorModal = require('../storeLocator/storeLocatorModal');

function varaitionNotSelectedError($pdpContainer) {
	let nonSelectedVariations = $pdpContainer.find('.variationOption').not(':has(.variation-value.selected)');
	for (let i = 0; i < nonSelectedVariations.length; i++) {
		let errorMsg = $(nonSelectedVariations[i]).data('attr-missing-error');
		$(nonSelectedVariations[i]).addClass('variation-missing-error');
		$(nonSelectedVariations[i]).find('.variation-not-selected-error').text(errorMsg);
		$(document).trigger('gtm:pdpVariationErrors', errorMsg);
	}
	if($pdpContainer.find('.variation-missing-error').length > 0) {
		$(document).scrollTop($pdpContainer.find('.variation-missing-error').offset().top);
	}
}

function updateAttribute() {
	$('body').on('product:afterAttributeSelect', function (e, response) {
		if ($('.product-detail>.bundle-items').length) {
			response.container.data('pid', response.data.product.id);
			response.container.find('.product-id').text(response.data.product.id);
			response.container.find('.special-message-sku').empty().html(response.data.product.messageSlot2);
		} else if ($('.product-set-detail').eq(0)) {
			response.container.data('pid', response.data.product.id);
			response.container.find('.product-id').text(response.data.product.id);
			response.container.find('.special-message-sku').empty().html(response.data.product.messageSlot2);
		} else {
			$('.product-id').text(response.data.product.id);
			$('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
			response.container.find('.special-message-sku').empty().html(response.data.product.messageSlot2);
		}

		var productSet = $('.set-item').find('.sales').children('.value');
		var setPrice = 0;
		productSet.each(function () {
			setPrice += parseInt($(this).attr('content'));
		});
		$('.pdp-set-totalprice').text('$' + setPrice + '.00');

		var readyToOrderProduct = response.data.product.readyToOrder;
		var addAlltocarterror  = $('.add-to-cart-global').attr('data-error-message');
		$('.add-to-cart-global').addClass('disabled');
		if($('.product-set-detail').length > 0 && readyToOrderProduct && addAlltocarterror == null){
			$('.add-to-cart-global').removeClass('disabled');
		}
		// update store finder productId
		const storeLocatorProductId = $('form.store-locator input[name="productId"]');
		if (storeLocatorProductId.length) {
			storeLocatorProductId[0].value = response.data.product.id;
		}
	});
	$('.pickAHolderButton').on('click', function () {
		$(this).parent().find('.artGlassAlert').remove();
		const artGlass = $('[data-attr="artGlass"]');
		const letterName = $('[data-attr="letterName"]');
		let isArtGlassSelected = true;
		let letterNameSelected = true;

		if (artGlass) {
			isArtGlassSelected = artGlass
				.find('.attribute')
				.children()
				.children('.selectable')
				.hasClass('selected');
		}
		if (letterName) {
			letterNameSelected = letterName
				.find('.character-square')
				.children()
				.hasClass('active');
		}

		if (!isArtGlassSelected || !letterNameSelected) {
			const alertDialog =
				'<div class="alert alert-danger artGlassAlert" role="alert">Please review missing item details and make a selection</div>';
			$(this).parent().prepend(alertDialog);
			setTimeout(() => {
				$('.artGlassAlert').fadeOut();
			}, 6000);
		}
	});
}

$(document).on('click','.product-detail.set-item .yotpo-display-wrapper a',function(){
	$(this).parents('.setreviewLink')[0].click();
});

window.addEventListener('load', function(){
	sessionStorage.pagedata = $('.page').data('action');
});

window.addEventListener('unload', function(){
	sessionStorage.pagedata = $('.page').data('action');
});

$(document).on('click','.breadcrumb-item a',function(){
	if(sessionStorage.scrollPos){
		sessionStorage.scrollPos = 0;
	}
});

$(document).ready(function () {
	sessionStorage.pagedata = 'Product-Show';
});


var exportDetails = $.extend({}, base, detail, {
	addToCart: base.addToCart,
	attributeSelect: base.attributeSelect,
	availability: base.availability,
	updateAttribute: updateAttribute,
	hideWishlistIconPOS: function() {
		$(document).ready(function() {
			if($('.header-login').find('.posMode').length > 0){
				$('.wishlist-posHide').hide();
			}
		});
	},
	productVariationPDP: function () {
		$('.swatch-circle').each(function () {
			let variantClickType = $(this).attr('data-id');
			if($('.product-set-detail') && $('.product-set-detail').length > 0){
				let swatchname = $(this).parents('.variation-attribute').find('.swatch-circle.selected' + '.' + variantClickType + '-value').attr('data-label-name');
				if (typeof swatchname !== 'undefined') {
					let typeData = $(this).parents('.variation-attribute').find('#swatch_name_label').attr('type-check');
					if (variantClickType == typeData) {
						let presentData = $(this).parents('.variation-attribute').find('#swatch_name_label').text();
						let swatchData = presentData.split(':');
						$(this).parents('.variation-attribute').find('#swatch_name_label').text(swatchData[0] + ' : ' + swatchname);
					}
					else {
						let presentData = $(this).parents('.variation-attribute').find('#swatch_name_label' + '.' + variantClickType).text();
						let swatchData = presentData.split(':');
						$(this).parents('.variation-attribute').find('#swatch_name_label' + '.' + variantClickType).text(swatchData[0] + ' : ' + swatchname);
					}
				}
			} else {
				let swatchname = $('.swatch-circle.selected' + '.' + variantClickType + '-value').attr('data-label-name');
				if (typeof swatchname !== 'undefined') {
					let typeData = $('#swatch_name_label').attr('type-check');
					if (variantClickType == typeData) {
						let presentData = $('#swatch_name_label').text();
						let swatchData = presentData.split(':');
						$('#swatch_name_label').text(swatchData[0] + ' : ' + swatchname);
					}
					else {
						let presentData = $('#swatch_name_label' + '.' + variantClickType).text();
						let swatchData = presentData.split(':');
						$('#swatch_name_label' + '.' + variantClickType).text(swatchData[0] + ' : ' + swatchname);
					}
				}
			}
		});

		$('.swatch-circle').on('click', function (e) {
			e.preventDefault();
			let swatchname = $(this).attr('data-label-name');
			let variantClickType = $(this).attr('data-id');
			if($('.product-set-detail') && $('.product-set-detail').length > 0){
				let typeData = $(this).parents('.variation-attribute').find('#swatch_name_label').attr('type-check');

				if (variantClickType == typeData) {
					let presentData = $(this).parents('.variation-attribute').find('#swatch_name_label').text();
					let swatchData = presentData.split(':');
					$(this).parents('.variation-attribute').find('#swatch_name_label').text(swatchData[0] + ' : ' + swatchname);
				}
				else {
					e.preventDefault();
					let presentData = $(this).parents('.variation-attribute').find('#swatch_name_label' + '.' + variantClickType).text();
					let swatchData = presentData.split(':');
					$(this).parents('.variation-attribute').find('#swatch_name_label' + '.' + variantClickType).text(swatchData[0] + ' : ' + swatchname);
				}
			} else {
				let typeData = $('#swatch_name_label').attr('type-check');

				if (variantClickType == typeData) {
					let presentData = $('#swatch_name_label').text();
					let swatchData = presentData.split(':');
					$('#swatch_name_label').text(swatchData[0] + ' : ' + swatchname);
				}
				else {
					e.preventDefault();
					let presentData = $('#swatch_name_label' + '.' + variantClickType).text();
					let swatchData = presentData.split(':');
					$('#swatch_name_label' + '.' + variantClickType).text(swatchData[0] + ' : ' + swatchname);
				}
			}
		});

		$('.character-attribute').on('click', function (e) {
			e.preventDefault();
			$(this).parent().children().removeClass('active');
			$(this).addClass('active');
		});
		let letterType = $( '.character-attribute' );
		//	let variantValue = $( '.select-box' ).attr('data-attr-value');
		let numberVrnQty = letterType.attr('numbersize-check');
	
		$('.character-attribute').each(function () {
			var characterData = $(this).attr('data-variant');
			var variantValue = $(this).attr('data-attr-value');
			if(characterData == 'letterName'){
				letterType.addClass('LetterActive');
				letterType.parents('.character-square').addClass('LetterActiveWrapper');
			}
			else if(characterData == 'numberName'){
				if(numberVrnQty == null || numberVrnQty == 'null'){
					if(characterData == 'numberName'){
						letterType.addClass('YearActive');
						letterType.parents('.character-square').addClass('YearActiveWrapper');
					}
				}
				else {
					$( '.Dropdown-number' ).removeClass('disableDropdown');
					$( '.character-square' ).addClass('activeNumber');
				}
			}
			else if(characterData == 'year' || characterData == 'gcDenomination')
			{
				letterType.addClass('YearActive');
				letterType.parents('.character-square').addClass('YearActiveWrapper');
			}
			else if(characterData == 'size')
			{
				$(this).parent().children().removeClass('LetterActive');
				if(isNaN(variantValue) === false){
					$(this).addClass('sizeSqrAct');
					$(this).parents('.character-square').addClass('sizeSqrActWrapper');

				}
				else {
					$(this).addClass('SizeRectActive');
					$(this).parents('.character-square').addClass('SizeRectActiveWrapper');
				}
			}
		});
	},
	updateAddToCart: function () {
		$('body').on('product:updateAddToCart', function (e, response) {
			var selectionComplete = false;
			if (!response.product.product.readyToOrder) {
				var varianceSelectionErrorMsg = $('#not-ready-error-message').val();
				$('button.add-to-cart', response.$productContainer).attr('data-error-message', varianceSelectionErrorMsg);
				$('button.add-to-cart', response.$productContainer).attr('data-readyto-order',response.product.product.readyToOrder);
				if ($('button.add-to-cart-global').length) {
					$('button.add-to-cart-global').attr('data-error-message',varianceSelectionErrorMsg);
					$('button.add-to-cart-global').attr('data-readyto-order',response.product.product.readyToOrder);
				}
			} else if (!response.product.product.available) {
				if (response.product.product.inventoryMessage && response.product.product.inventoryMessage.availabilityStatusClass === 'urgent') {
					$('button.add-to-cart', response.$productContainer).attr('data-urgency-message', true);
					$('button.add-to-cart-global', response.$productContainer).attr('data-urgency-message', true);
					$('button.add-to-cart-global').removeAttr('data-error-message');
					$('button.add-to-cart').removeAttr('data-error-message');
				} if (response.product.product.inventoryMessage && response.product.product.inventoryMessage.availabilityStatusClass == 'outOfStock' &&  response.product.product.realTimeStoreInventory && response.product.product.realTimeStoreInventory.availabilityStatusClass == 'inStock') {
					$('button.add-to-cart-global').removeAttr('data-error-message');
					$('button.add-to-cart').removeAttr('data-error-message');
				} else {
					$('.variation-selection-error-message').addClass('d-none');
					if (!$('button.add-to-cart', response.$productContainer).attr('data-urgency-message')) {
						$('button.add-to-cart', response.$productContainer).attr('data-error-message', response.product.product.availability.messages[0]);
					}
					$('button.add-to-cart-global', response.$productContainer).attr('data-error-message', response.product.product.availability.messages[0]);
				}
			} else {
				$('button.add-to-cart', response.$productContainer).removeAttr('data-error-message');
				$('button.add-to-cart', response.$productContainer).removeAttr('data-urgency-message');
				if ($('.add-to-cart-global').length) {
					$('button.add-to-cart-global', response.$productContainer).removeAttr('data-urgency-message');
					$('.product-detail').each(function () {
						if (!$(this).hasClass('product-set-detail')) {
							var addtocartButton = $(this).find('button.add-to-cart');
							if (addtocartButton.attr('data-error-message')) {
								$('button.add-to-cart-global').attr('data-error-message',varianceSelectionErrorMsg);
								$('button.add-to-cart-global').attr('data-readyto-order',response.product.product.readyToOrder);
								selectionComplete = true;
							}
						}
					});
					if(!selectionComplete) {
						$('button.add-to-cart-global').removeAttr('data-error-message');
					}
				}
				$('.variation-selection-error-message', response.$productContainer).addClass('d-none');
			}

			if(response.product.product.productType === 'master'){
				if (response.product.cyoError) {
					$('button.btn-secondary-cyo', response.$productContainer).attr('data-error-message', response.product.cyoError);
					if (response.product.product.readyToOrder) {
						$('.cyo-error-message').addClass('d-none');
					}
				} else {
					$('button.btn-secondary-cyo', response.$productContainer).removeAttr('data-error-message');
					$('.cyo-error-message').addClass('d-none');
				}
			} else {
				if (response && response.product && response.product.product &&  response.product.product.cyoOrEngravingErrorMessage && (response.product.product.cyoOrEngravingErrorMessage.enableEngraving == false || response.product.product.cyoOrEngravingErrorMessage.pickHolderOrCharm == false)) {
					if (response.product.product.readyToOrder) {
						$('.cyo-error-message').addClass('d-none');
					}
					
					if (response.product.product.cyoOrEngravingErrorMessage.enableEngraving == false){
						$('button.btn-cyo-engrave', response.$productContainer).attr('data-error-message', response.product.product.cyoOrEngravingErrorMessage.errorMessage);
					} 
					if (response.product.product.cyoOrEngravingErrorMessage.pickHolderOrCharm == false){
						$('button.btn-cyo-pick-holder', response.$productContainer).attr('data-error-message', response.product.product.cyoOrEngravingErrorMessage.errorMessage);
						$('button.btn-cyo-addCharm', response.$productContainer).attr('data-error-message', response.product.product.cyoOrEngravingErrorMessage.errorMessage);
					}
					if (response.product.product.cyoOrEngravingErrorMessage.enableEngraving == false && response.product.product.cyoOrEngravingErrorMessage.pickHolderOrCharm == true){
						$('button.btn-cyo-pick-holder', response.$productContainer).removeAttr('data-error-message');
						$('button.btn-cyo-addCharm', response.$productContainer).removeAttr('data-error-message');
					}
					if (response.product.product.cyoOrEngravingErrorMessage.pickHolderOrCharm == false && response.product.product.cyoOrEngravingErrorMessage.enableEngraving == true){
						$('button.btn-cyo-engrave').removeAttr('data-error-message');
					}
				} else {
					$('button.btn-secondary-cyo').removeAttr('data-error-message');
					
					$('.cyo-error-message').addClass('d-none');
				}
			}

			$('button.btn-secondary-cyo', response.$productContainer).attr('data-pid', response.product.product.id);

			var enable = $('.product-availability').toArray().every(function (item) {
				return $(item).data('available') && $(item).data('ready-to-order');
			});
			module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
		});
	},

	pdpStoreSelection: function () {
		$(document).on('click', '.find-a-store-pdp', function (e) {
			e.preventDefault();
			var findStoreLink = $(this);
			var setItemEle = $(this).parents('.product-detail.set-item');
			var productSet = setItemEle && setItemEle.length > 0 ? true : false;
			var readyToOrder = productSet > 0 ? $(this).parents('.attributes').find('button.add-to-cart').attr('data-readyto-order') : $('button.add-to-cart').attr('data-readyto-order');
			if (readyToOrder === false || readyToOrder === 'false') {

				var $pdpContainer = productSet ? setItemEle : $(this).closest('.product-detail');
				var shippingStock = $pdpContainer.find('.shipping-delivery-selection .availability-msg');
				var pickupStoreStock = $pdpContainer.find('.shipping-pickup-store .availability-msg');
				var pdpStockMsgShown = shippingStock.find('.inStock').length > 0 || shippingStock.find('.outOfStock').length > 0 || 
										pickupStoreStock.find('.inStock').length > 0 || pickupStoreStock.find('.outOfStock').length > 0 ? true : false;

				if ($pdpContainer.find('.variation-value.selected').length === $pdpContainer.find('.variationOption').length && !pdpStockMsgShown) {
					// If all variation options selected and no stock messages shown, whether OOS/IS this implies 
					// selected variation not available for product.Then show not available message, else continue to appropriate error msg
					$pdpContainer.find('.variation-selection-error-message').removeClass('d-none');
					$pdpContainer.find('.selection-error-message').text($(this).parents('.attributes').find('button.add-to-cart').attr('data-not-available'));
				}else if ($('.variation-selection-error-message').length && $('.variation-selection-error-message').hasClass('d-none')) {
					if(productSet){
						$(this).parents('.attributes').find('#storeModalDialog').modal('hide');
						varaitionNotSelectedError(setItemEle);
					}else{
						$('#storeModalDialog').modal('hide');
						varaitionNotSelectedError($pdpContainer);					}
				}
				return false;
			}
			var urlNew = productSet ? $(this).parents('.attributes').find('.findStoreNew').val() : $('.findStoreNew').val();
			let pid = productSet ? $(this).parents('.set-item').find('.product-id').text() : $('.product-id').text();
			urlNew += '&pid='+pid;
			$.spinner().start();
			var storeModalHtml;
			var thisVar = $(this);
			var storeLocatorContainer = productSet ? $(this).parents('.attributes').find('.store-locator-container') : $('.store-locator-container');
			if (storeLocatorContainer && storeLocatorContainer.length > 0) {
				storeLocatorModal.getStoreModal(thisVar);
			} else {
				$.ajax({
					url: urlNew,
					method: 'GET',
					success: function (result) {
						storeModalHtml = result;
						if(productSet) {
							findStoreLink.parents('.attributes').find('#storeModalDialog .modal-body').html(storeModalHtml);
						} else {
							$('#storeModalDialog .modal-body').html(storeModalHtml);
						}
						storeLocatorModal.getStoreModal(thisVar);
						clientSideValidation.invalid();
						clientSideValidation.buttonClick();
						var storeLocatorInput = document.querySelector(
							'.store-locator .zipcode-input'
						);
						storeLocatorInput.addEventListener('invalid', () => {
							let data = {
								eventLabel: $.trim($('#store-postal-code-error').text()),
								eventAction: 'Message Displayed',
							};
							$('body').trigger('storeloc:nozipcodeerr', data);
						});
					}
				});
			}
		});

	},

	
	updateAvailability: function () {
		$('body').on('product:updateAvailability', function (e, response) {
			$('.quantity-right-plus', response.$productContainer).removeClass('disabled');
			$('.quantity-left-minus', response.$productContainer).removeClass('disabled');
			$('.quantity-input', response.$productContainer).removeClass('disabled');
			

			if(response.product) {
				$('div.availability', response.$productContainer)
					.data('ready-to-order', response.product.readyToOrder)
					.data('available', response.product.available);
				$('button.add-to-cart', response.$productContainer)
					.attr('data-readyto-order', response.product.readyToOrder);
				$('.shipping-msg', response.$productContainer)
					.empty().html(response.shippingMessage);
			}

			$('.pickup-msg', response.$productContainer)
				.empty().html(response.pickupMessage);

			if (response.product && response.product.inventoryMessage && response.product.inventoryMessage.availabilityStatusClass === 'outOfStock' && response.product.realTimeStoreInventory && response.product.realTimeStoreInventory.availabilityStatusClass === 'outOfStock') {
				$('button.add-to-cart', response.$productContainer).attr('data-error-message', response.unavailableMsg);
				$('.quantity-right-plus', response.$productContainer).addClass('disabled');
				$('.quantity-left-minus', response.$productContainer).addClass('disabled');
				$('.quantity-input', response.$productContainer).addClass('disabled');
			} else {
				$('button.add-to-cart', response.$productContainer).removeAttr('data-error-message');
				var dataqty = $('.shipping-msg').attr('data-qty');
				if(typeof dataqty === 'undefined' || dataqty === 'null'){
					return;
				}
				else if (!$('.variation-selection-error-message').hasClass('d-none')) {
					$('.variation-selection-error-message', response.$productContainer).addClass('d-none');
				}
			}


			if ($('.shipping-pickup-store', response.$productContainer).attr('data-nostore-selection') && response.product && response.product.myStore && response.product.myStore.store) {
				$('.shipping-pickup-store', response.$productContainer).removeAttr('data-nostore-selection');
				if (!$('.variation-selection-error-message').hasClass('d-none')) {
					$('.variation-selection-error-message', response.$productContainer).addClass('d-none');
				}
			}
			if ($('.global-availability').length) {
				var allAvailable = $('.product-availability').toArray()
					.every(function (item) { return $(item).data('available'); });

				var allReady = $('.product-availability').toArray()
					.every(function (item) { return $(item).data('ready-to-order'); });

				$('.global-availability')
					.data('ready-to-order', allReady)
					.data('available', allAvailable);

				$('.global-availability .availability-msg').empty()
					.html(allReady ? response.message : response.resources.info_selectforstock);
			}
		});
	}
});


quantitySelect.initQuantitySelector();
module.exports = exportDetails;
